import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/NotFound";
import { Route, Switch } from "wouter";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";

import Home from "./pages/Home";

// Lazy-load routes that are not on the critical path
const PulsePage = lazy(() => import("./pages/PulsePage"));
const BlogIndex = lazy(() => import("./pages/BlogIndex"));
const BlogPost = lazy(() => import("./pages/BlogPost"));
const ChatPage = lazy(() => import("./pages/ChatPage"));

// Loading fallback component
function LoadingFallback() {
  return (
    <div className="min-h-screen bg-[#09090B] flex items-center justify-center">
      <div className="text-zinc-400">Loading...</div>
    </div>
  );
}


function Router() {
  return (
    <Switch>
      <Route path={"/"} component={Home} />
      <Route path={"/pulse"}>
        <Suspense fallback={<LoadingFallback />}>
          <PulsePage />
        </Suspense>
      </Route>
      <Route path={"/blog"}>
        <Suspense fallback={<LoadingFallback />}>
          <BlogIndex />
        </Suspense>
      </Route>
      <Route path={"/blog/:slug"}>
        <Suspense fallback={<LoadingFallback />}>
          <BlogPost />
        </Suspense>
      </Route>
      <Route path={"/chat"}>
        <Suspense fallback={<LoadingFallback />}>
          <ChatPage />
        </Suspense>
      </Route>
      <Route path={"/404"} component={NotFound} />
      {/* Final fallback route */}
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider defaultTheme="dark">
        <TooltipProvider>
          <>
            <Toaster />
            <Router />
          </>
        </TooltipProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
